import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is ecommerce software development, and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Ecommerce software development is the process of creating custom software
                                        solutions for online stores and other types of ecommerce businesses. These
                                        solutions can help businesses to streamline their operations, improve customer
                                        experience, and increase sales by providing features like online shopping cart
                                        systems, payment gateways, and inventory management tools.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are some common features of ecommerce software development projects?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Some typical features of ecommerce software development projects include online
                                        shopping cart systems, payment gateways, inventory management tools, customer
                                        relationship management (CRM) systems, and marketing automation tools. Other
                                        features may include shipping and logistics integration, order tracking, and
                                        analytics and reporting capabilities.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How can TekRevol help me with my ecommerce software development project?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol has a team of experienced software developers who are proficient in
                                        various programming languages and frameworks and well-equipped to handle
                                        ecommerce software development projects of any size and complexity. We work
                                        closely with our clients to understand their unique business needs and goals and
                                        help them create custom software solutions that drive growth and success.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;